
export function parseCsv (text = '', seperator = ',') {
    // to json format, list of dictionaries

    const rows = text.split(/\r\n|\n/) || []
    
    const headers = rows[0].split(seperator)
    
    // remove first array
    rows.shift()
    const body = rows
    const lines = []
  
    if (!body) {
      return []
    }
  
    body.forEach((line) => {
      if (!line || line.trim() === '') {
        return; // Skip empty lines
      }
      
      // We must respect quoted strings, such as "RUSKIN, Paul"
      const data = [];
      let inQuotes = false;
      let currentValue = '';
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === seperator && !inQuotes) {
          data.push(currentValue);
          currentValue = '';
        } else {
          currentValue += char;
        }
      }
      
      // Push the last value
      data.push(currentValue);

      // default csv import with uuid field, will overwrite if it contains in csv
      // reason is for backend sentry parsing of unclear data format errors
      const row = {
        _meta: {
          headers,
          line
        }
      }
      
      headers.forEach((header, j) => {
        row[header] = data[j]
      })
      lines.push(row)

    })

    return lines
  }
  